export var InsertFreeThrowsSetup = {
  name: "insert-freethrows-setup",
  component: "MainPanel",
  layout: "main-panel large center no-group",
  mode: "visible",
  text: "freethrows.add",
  showOn: [{ state: "editState", value: "child-insert-freethrows", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit-0", "edit-1"] },
  children: [
    //Pre - action - runs before select
    {
      name: "pre-action",
      component: "PreAction",
      layout: "pre-action",
      mode: "enable",
      text: "freethrow.none",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      inheritPlay: "foul",
      actionGroups: [
        {
          actions: [
            {
              action: "copyFromPlay",
              value: {
                eventTypes: ["foul"],
                ignoreSubTypes: ["drawn"],
                copyTo: "foul",
              },
              type: "edit",
            },
            {
              action: "copyFromPlay",
              value: {
                eventTypes: ["foul"],
                ignoreSubTypes: [
                  "benchTechnical",
                  "coachDisqualifying",
                  "coachTechnical",
                  "disqualifying",
                  "offensive",
                  "personal",
                  "technical",
                  "unsportsmanlike",
                ],
                copyTo: "fouldrawn",
              },
              type: "edit",
            },
            { action: "copyEvent", value: "foul", type: "from" },
            {
              action: "saveData",
              value: [{ option: "freeThrows", value: 1 }],
              type: "options",
            },
            {
              action: "sendEvent",
              value: "edit",
              type: "main",
            },
            {
              action: "nextState",
              value: "child-insert-freethrows-modal",
              type: "editState",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};

export const InsertFreeThrows = {
  name: "free-throws-panel",
  component: "MainPanel",
  layout: "main-panel full align-center",
  mode: "visible",
  text: "freethrows",
  allowFlag: true,
  allowCancel: true,
  allowCancelEvent: "main",
  showOn: [{ state: "editState", value: "child-insert-freethrows-modal", operator: "is" }],
  children: [
    {
      name: "free-throw-select-panel",
      component: "SimpleFreeThrows",
      layout: "free-throws full",
      mode: "enable",
      text: null,
      showOn: [true],
      options: {
        allowAddingNew: true,
        currentEntity: false,
        currentEntityEvent: "foul",
      },
      actionGroups: [
        {
          actions: [{ action: "clearEvent", value: "freethrow", type: "main" }],
          conditions: [],
        },
        {
          actions: [{ action: "nextState", value: null, type: "editState" }],
          conditions: [{ item: "success", value: true, event: "main", operator: "is" }],
        },
        {
          actions: [
            {
              action: "nextState",
              value: "shot-rebound-insert",
              type: "editState",
            },
          ],
          conditions: [
            { item: "success", value: false, event: "main", operator: "is" },
            {
              item: "subType",
              value: "technical",
              event: "foul",
              operator: "not",
            },
          ],
        },
        {
          actions: [{ action: "nextState", value: null, type: "editState" }],
          conditions: [
            { item: "success", value: false, event: "main", operator: "is" },
            {
              item: "subType",
              value: "technical",
              event: "foul",
              operator: "is",
            },
          ],
        },
      ],
    },
  ],
};
